import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import FormFieldWrapper from '../../../../../common/components/FormFieldWrapper/FormFieldWrapper';
import PaneSection from '../../../../../common/components/PaneSection/PaneSection';
import TextInput from '../../../../../common/components/TextInput';
import { ProfileImage } from '../../../../../editor/features/liveChat/components/ProfileImage/ProfileImage';
import usersCRUDActions from '@mm/state/actions/UsersCRUDActions';
import { selectCurrentUser } from '@mm/state/selectors/userSelector';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import './ProfilePaneSection.pcss';
import { EMAIL_REGEX } from '../../../../../common/constants/validations';

export const ProfilePaneSection = () => {
  const dispatch = useDispatch();
  const company = useSelector(activeCompanySelector);
  const currentUser = useSelector(selectCurrentUser);
  const [email, setEmail] = useState<string | undefined>();
  useEffect(() => {
    setEmail(m => m ?? currentUser?.email);
  }, [currentUser]);

  useEffect(() => {
    if (!currentUser && company) {
      dispatch(usersCRUDActions.retrieveAll(company.id));
    }
  }, [dispatch, currentUser, company]);

  const saveEmail = () => {
    if (company && currentUser && email) {
      dispatch(usersCRUDActions.update(company.id, { ...currentUser, email }));
    }
  };
  const emailDirty = currentUser && email !== currentUser.email;
  const valid = email && EMAIL_REGEX.test(email);
  return (
    <PaneSection classNameBody="profile-pane-section__body">
      <ProfileImage
        altText="Profile Image"
        profilePictureUrl={currentUser?.image}
        className="profile-pane-section__profile-image"
      />
      <div className="profile-pane-section__fields">
        <div className="profile-pane-section__names">
          <FormFieldWrapper label="First Name">
            <TextInput
              disabled
              style={{ backgroundColor: '#efefef' }}
              value={currentUser?.firstName}
            />
          </FormFieldWrapper>
          <FormFieldWrapper label="Last Name">
            <TextInput
              disabled
              style={{ backgroundColor: '#efefef' }}
              value={currentUser?.lastName}
            />
          </FormFieldWrapper>
        </div>
        <FormFieldWrapper label="Email">
          <TextInput
            value={email || ''}
            disabled={!currentUser}
            onChange={e => setEmail(e.target.value)}
            error={email !== undefined && !valid}
          />
        </FormFieldWrapper>
        <FormFieldWrapper label="Role">
          <TextInput
            disabled
            style={{ backgroundColor: '#efefef' }}
            value={currentUser?.role}
          />
        </FormFieldWrapper>
        {emailDirty && (
          <PrimaryButton
            className="profile-pane-section__save-button"
            disabled={!valid}
            onClick={saveEmail}
          >
            Save
          </PrimaryButton>
        )}
      </div>
    </PaneSection>
  );
};
